export default __webpack_public_path__ + "assets/favicon.62240f8b.png";